<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" [formGroup]="editForm" (ngSubmit)="save()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.marketing.description' | translate }}</span>
        </h2>
        <div class="ir-form-group margin">
          <textarea
            id="description"
            formControlName="description"
            rows="3"
            placeholder="{{ 'plugins.comment.your-comment' | translate }}"
            class="ir-form-set"
          ></textarea>
        </div>
        <h2>
          <span>{{ 'plugins.marketing.presentations' | translate }}</span>
        </h2>
        <div class="ir-form-group margin" *ngIf="links">
          <div class="ir-item-line th-section-dark" *ngFor="let item of links; let i = index">
            <div class="ir-item-cell s8 strong">
              <span>{{ item.Description }}</span>
            </div>
            <div class="ir-item-cell s2 right strong statut">
              <span class="important clickable" (click)="navigateTo(item.Url)">
                {{ 'common.view' | translate }}
                <i class="material-icons warning">link</i>
              </span>
              <i (click)="remove(i)" class="material-icons warning clickable">remove_circle</i>
            </div>
          </div>
        </div>
        <div class="ir-content--modal th-content th-content-plus" *ngIf="isConnection">
          <table class="ir-modal-table">
            <tr class="th-plugin-line--add th-plugin-line--add-customer">
              <td colspan="4">
                <i class="material-icons" (click)="openPresentationsPickerMOdal()">add_circle</i>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="addPresentations($event)" #presentationsModal></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
